// #POW-6
import Config from '../../Config';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, CircularProgress, Box, TextField, Typography, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useCustomFetch from '../../hooks/useCustomFetch';
import { GridValidRowModel } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next"; // #POW-29

function formattedDate(date: string | Date) { 
    return new Intl.DateTimeFormat('it-IT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(new Date(date));
};

export default function DialogTrackingNumber(
    { open, onClose, selectedRows, refreshDataGrid }: { open: boolean; onClose: () => void; selectedRows?: GridValidRowModel[]; refreshDataGrid: (value: boolean) => void  }
){
    const { t } = useTranslation();  // #POW-29
    const customFetch = useCustomFetch() // #POW-14
    const [isLoading, setIsLoading] = useState(false) // #POW-14
    const [isError, setIsError] = useState(false) // #POW-6
    const [isSuccess, setIsSuccess] = useState(false) // #POW-6
    const [errorList, setErrorList] = useState("") // #POW-6
    const [errorListCount, setErrorListCount] = useState(0) // #POW-6
    const [dataSent, setDataSent] = useState(false) // #POW-6


    const handleClose = () => { // #POW-6
        if(dataSent)
            refreshDataGrid(true)

        onClose();
        setTimeout(
            function () {  
                setIsError(false);
                setIsSuccess(false);  
                setErrorList("");
                setErrorListCount(0);
            }, 
            500)
       
      };

    // Save trackingnumber for selected transactions
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        setIsLoading(true);
        setIsError(false);  // #POW-6
        setIsSuccess(false);  // #POW-6
        setErrorList("");  // #POW-6
        setErrorListCount(0);  // #POW-6

        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const trackingnumber = formJson.trackingnumber;

        const url = `${Config.serverUrl}/api/trade-in/transactions/mark-as-sent`;
        const response = await customFetch(url, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ "shipping_code": trackingnumber, transactions: selectedRows?.map((t) => t.id )}),
        });
      
        if (response.ok) {  // #POW-6
            const resonseData = await response.json();
            
            if(resonseData.status == "success")
            {
                setIsSuccess(true);
            }
            else
            {
                setIsError(true);
                setErrorListCount(resonseData.list.length)
                setErrorList(resonseData.list.join("\n"))
            }

            setDataSent(true) // #POW-6
        }
        else{
            setIsError(true)
            setErrorListCount(selectedRows ? selectedRows.length: 0)
            const errList = selectedRows? selectedRows.map((t) => t.id ) : [];
            setErrorList(errList.join("\n"))
        }

        setIsLoading(false)
        //onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth='md'>

            {isLoading && (
                <>
                <DialogTitle fontWeight={'bold'}>{t("transactions.dialog.loading")}</DialogTitle>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <CircularProgress />
                </div>
                </>
            )}

            {!isLoading && (
                <form onSubmit={handleSubmit}>
                    <DialogTitle fontWeight={'bold'}>{t("transactions.dialog.title")}</DialogTitle>
                    <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                    >
                    <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        {selectedRows && selectedRows?.length >1 && <Typography sx={{ mb: 1 }} >
                            {t('transactions.dialog.text', { value: selectedRows?.length })}
                        </Typography>} {/* #POW-6 */}
                        {selectedRows && selectedRows?.length == 1 && <Typography sx={{ mb: 1 }} >
                            {t('transactions.dialog.textSingle')}
                        </Typography>} {/* #POW-6 */}
                        <Box sx={{
                            mb: 2,
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: 300,
                            overflow: "hidden",
                            overflowY: "scroll",
                            border: "1px solid #cccccc"
                        }}>
                            {selectedRows && selectedRows.map((row:GridValidRowModel, index: number) => 
                                <p
                                    key={index}
                                    style={{
                                    backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#ffffff",
                                    margin: 0,
                                    padding: "8px",
                                    }}
                                >
                                    <b>{row.id}</b> - {row.device_name} ({formattedDate(row.date)})
                                </p> 
                            )}
                        </Box>
                    
                        {!isSuccess && <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="trackingnumber"
                            name="trackingnumber"
                            label={t("transactions.dialog.trackingNumber")}
                            type="text"
                            fullWidth
                            variant="standard"
                        />} {/* #POW-6 */}
                        {isSuccess && <Alert severity="success" variant="outlined">{t("incomingTransactions.dialog.success")}</Alert>} {/* #POW-6 */}
                        {isError && errorListCount==1 && 
                            <Alert severity="error" variant="outlined" sx={{maxHeight:"200px", width:"100%"}}>
                                {t("incomingTransactions.dialog.errorSingle")}<br/>
                            </Alert>} {/* #POW-6 */}
                        {isError && errorListCount>1 && 
                            <Alert severity="error" variant="outlined" sx={{maxHeight:"200px", width:"100%"}}>
                                {t("incomingTransactions.dialog.error", { value: errorListCount })}<br/>
                                <pre>{errorList}</pre>
                            </Alert>} {/* #POW-6 */}
                    </DialogContent>
                    <DialogActions>
                    {!isSuccess && 
                        <>
                            <Button autoFocus onClick={handleClose} color="primary" variant="outlined">{t("transactions.dialog.cancel")}</Button>
                            <Button type="submit" color="primary" variant="contained">{t("transactions.dialog.save")}</Button>
                        </>
                    } {/* #POW-6 */}
                    {isSuccess && <Button autoFocus onClick={handleClose} color="primary" variant="contained">{t("transactions.dialog.close")}</Button>} {/* #POW-6 */}
                    </DialogActions>
                </form>
            )}

        </Dialog>
    )
}